export default __webpack_public_path__ + "static/media/turkey_gray.66c214dd.svg";